import type * as Types from '@formic/fusion-graphql/schema';
import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export type HomeScreenThemesByIdQueryVariables = Types.Exact<{
  themeId: Types.Scalars['Int'];
}>;

export type HomeScreenThemesQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type HomeScreenThemesByIdQuery = { theme: { id: number, name: string, description: string, data: string }};

export type HomeScreenThemesQuery = { themes: Array<{ id: number, name: string, description: string, data: string }> };

export const HomeScreenThemesByIdDocument = /*#__PURE__*/ gql`
  query homeScreenTheme($themeId: Int!) {
    theme(themeId: $themeId) {
      id
      name
      description
      data
    }
  }
`;

export const HomeScreenThemesDocument = /*#__PURE__*/ gql`
  query homeScreenTheme {
    themes {
      id
      name
      description
      data
    }
  }
`;

export function useHomeScreenThemesByIdQuery(options: Omit<Urql.UseQueryArgs<HomeScreenThemesByIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HomeScreenThemesByIdQuery>({ query: HomeScreenThemesByIdDocument, ...options });
};

export function useHomeScreenThemesQuery(options: Omit<Urql.UseQueryArgs<HomeScreenThemesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HomeScreenThemesQuery>({ query: HomeScreenThemesDocument, ...options });
};